<template>
  <v-container>
    <div>
      <v-row justify="space-between" no-gutters>
        <v-col cols="12" sm="6" justify="center">
          <p class="header-title"> Thống kê điểm YCTK </p>
        </v-col>

        <v-col cols="12" sm="6" justify="center" class="pr-5">
          <v-row justify="start">
            <v-col cols="12" sm="3">
            </v-col>
            <v-col cols="12" sm="6">
              <v-dialog ref="dialog" v-model="modal" :return-value.sync="dates" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted" v-bind:label="$t('common.date_range')" readonly
                                v-on="on" outlined dense background-color="#ffffff">
                  </v-text-field>
                </template>
                <v-date-picker v-model="dates" scrollable range locale="vi" no-title>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }}</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(dates)"> {{ $t('common.ok') }}</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col cols="12" sm="3">
              <v-btn dark color="primary" @click="getDataStatisticTeam" large> Thống kê</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-container class="white">
      <v-row no-gutters>
        <v-col cols="12" sm="2">
          <v-autocomplete v-model="selectTopFilter" :items="topFilters" item-text="name"
                          v-bind:label="$t('statistic.top_filter')" outlined return-object dense></v-autocomplete>
        </v-col>
      </v-row>

      <GChart
          :settings="{packages: ['corechart']}"
          :data="chartDatas"
          :options="chartOptions"
          :createChart="(el, google) => new google.visualization.BarChart(el)"
          @ready="onChartReady"
      />
    </v-container>

    <v-overlay :value="overlay" :z-index="0">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <detail-effort-dialog v-model="effortDialog" :data="desserts"  @closeDialog="closeEffortDialog"
               v-if="desserts">
    </detail-effort-dialog>
  </v-container>
</template>

<script>
import {GChart} from 'vue-google-charts'
import moment from 'moment';
import DetailEffortDialog from "@/components/DetailEffortDialog";

export default {
  components: {
    GChart,
    DetailEffortDialog: DetailEffortDialog
  },

  data: () => ({
    overlay: false,
    chartsLib: null,
    dates: [],
    date: {},

    desserts: [],

    chartDatas: ['Tên', 'Nỗ lực', {role: 'annotation'}, 'Điểm', {role: 'annotation'}, 'Hoàn thành', {role: 'annotation'}, 'Tổng số', {role: 'annotation'}],

    resultDatas: [],

    teams: [],
    selectTeam: {},
    topFilters: [
      {name: 'Tất cả', value: -1},
      {name: 'Top 5', value: 5},
      {name: 'Top 10', value: 10},
      {name: 'Top 15', value: 15}
    ],
    selectTopFilter: {},

    materialStyles: [],
    heightChart: 0,

    modal: false,
    effortDialog: false
  }),

  watch: {
    selectTopFilter() {
      this.filterData();
    }
  },

  computed: {
    chartOptions() {

      return {
        title: 'Bảng thống kê YCTK',
        bars: 'horizontal', // Required for Material Bar Charts.
        hAxis: {format: 'decimal', textStyle: {fontSize: 14}},
        vAxis: {textStyle: {fontSize: 14}},
        height: this.heightChart,
        // colors: ['#363F7A'],
        colors: ['#DC143C', 'green', '#363F7A', '#FC6104'],
        annotations: {textStyle: {fontSize: 14}},
        animation: {
          startup: true,
          duration: 200,
          easing: 'inAndOut'
        },

        legend: {position: 'top', textStyle: {fontSize: 14}},
        chartArea: {top: 30, width: '80%'}
      }
    },

    computedDateFormatted() {
      if (this.dates.length < 2) {
        return;
      }

      this.sortDate();
      return this.formatDate(this.date.start) + ' ~ ' + this.formatDate(this.date.end);
    }
  },

  async created() {
    //   await this.getAllTeamDesigner();
    //   this.getDataStatistic();
    const startDate = moment(new Date().setDate(new Date().getDate() - 30)).format("YYYY-MM-DD");
    const endDate = moment(new Date()).format("YYYY-MM-DD");
    this.dates.push(startDate);
    this.dates.push(endDate);
    this.sortDate();

    await this.getDataStatisticTeam();
    this.selectTopFilter = this.topFilters[0];
  },

  methods: {
    onChartReady(chart, google) {
      const self = this;
      this.chartsLib = google,
          this.chartsLib.visualization.events.addListener(chart, 'select', function () {
            const index = chart.getSelection()[0].row;
            const team = self.resultDatas[index];
            if (team && team._id) {
              self.getDataStatisticForOneTeam(team);
            } else {
              const user = self.resultDatas[index];
              const column = chart.getSelection()[0].column;
              if (user.uid && column == 1) {
                self.getDetailDesignEffort(user.uid);
              }
            }

            chart.setSelection([])
          });
    },

    closeEffortDialog() {
      this.effortDialog = false;
      this.desserts = [];
    },

    sortDate() {
      const startDate = new Date(this.dates[0]);
      const endDate = new Date(this.dates[1]);

      if (startDate.getTime() < endDate.getTime()) {
        this.date.start = startDate;
        this.date.end = endDate;
      } else {
        this.date.start = endDate;
        this.date.end = startDate;
      }
    },

    formatDate(date) {
      if (!date) {
        return null;
      }
      return moment(date).format("DD/MM/YYYY");
    },

    initialize() {

    },

    async getDataStatisticTeam() {
      this.overlay = true;
      try {
        const from = moment(String(this.date.start)).format("DD/MM/YYYY");
        const to = moment(String(this.date.end)).format("DD/MM/YYYY");
        const response = await this.$http.get('/api/designRequest/teamDesignStats/all?' + "from=" + from + "&to=" + to);

        this.overlay = false;
        if (response.data && response.data.success) {
          this.resultDatas = [];

          const arrayData = response.data.data;
          if (arrayData) {
            arrayData.forEach(item => {
              const dataObject = {
                _id: item.team._id,
                name: item.team.name,
                effort: item.stats.numberOfEffortDesignRequest || 0,
                score: item.stats.numberOfDesignRequestHaveReward,
                finish: item.stats.numberOfCompleteDesignRequest,
                total: (item.stats.numberOfCompleteDesignRequest + item.stats.numberOfAccountantProcessingDesignRequest)
              }

              this.resultDatas.push(dataObject);
            });
          }

          setTimeout(() => this.generateDataForChart(this.resultDatas), 200);
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getDataStatisticForOneTeam(team) {
      this.overlay = true;
      try {
        const from = moment(String(this.date.start)).format("DD/MM/YYYY");
        const to = moment(String(this.date.end)).format("DD/MM/YYYY");

        const response = await this.$http.get('/api/designRequest/contextStatsByUsers/' + team._id + "?from=" + from + "&to=" + to);
        this.overlay = false;
        // console.log(response);
        if (response.data && response.data.success) {
          this.resultDatas = [];

          const arrayData = response.data.data;
          if (arrayData) {
            arrayData.forEach(item => {
              const dataObject = {
                uid: item.user._id,
                name: item.user.fullname,
                effort: item.numberOfEffortDesignRequest || 0,
                score: item.numberOfDesignRequestHaveReward,
                finish: item.numberOfCompleteDesignRequest,
                total: (item.numberOfCompleteDesignRequest + item.numberOfAccountantProcessingDesignRequest)
              }

              this.resultDatas.push(dataObject);
            });
          }

          setTimeout(() => this.generateDataForChart(this.resultDatas), 200);
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getDetailDesignEffort(uid) {
      // const self = this;
      this.overlay = true;
      try {
        const from = moment(String(this.date.start)).format("DD/MM/YYYY");
        const to = moment(String(this.date.end)).format("DD/MM/YYYY");

        const response = await this.$http.get('/api/designRequest/effortStats/' + uid + "?from=" + from + "&to=" + to);
        this.overlay = false;
        // console.log(response);
        if (response.data && response.data.success) {
          this.desserts = response.data.data;
          this.desserts.forEach((item, index) =>item.index = index + 1);
        }
      } catch (e) {
        console.log(e.stack);
      } finally {
        this.effortDialog = true;
      }
    },

    generateDataForChart(arrayData) {
      this.chartDatas = [];
      this.chartDatas.push(['Tên', 'Nỗ lực', {role: 'annotation'}, 'Điểm', {role: 'annotation'}, 'Hoàn thành', {role: 'annotation'}, 'Tổng số', {role: 'annotation'}]);

      if (Array.isArray(arrayData) && arrayData.length > 0) {
        arrayData.forEach(item => {
          this.chartDatas.push([item.name, item.effort, item.effort, item.score, item.score, item.finish, item.finish, item.total, item.total]);
        });
      }

      this.heightChart = this.chartDatas.length * 100 + 100;
    },

    filterData() {
      if (!this.resultDatas || this.resultDatas.length == 0) {
        return;
      }

      let dataArray = [].concat(this.resultDatas);

      if (this.selectTopFilter.value > 0) {
        this.sortData(dataArray);
        dataArray = dataArray.slice(0, this.selectTopFilter.value);
      }

      this.generateDataForChart(dataArray);
    },

    sortData(array) {
      function compare(a, b) {
        if (a.number < b.number)
          return 1;
        if (a.number > b.number)
          return -1;
        return 0;
      }

      array.sort(compare);
    },
  }
}
</script>